import React from "react";
import "./modal.scss";
import { ButtonGroup, Modal } from "react-bootstrap";

const ErrorModal = ({
  show,
  onHide,
  errorMessage,
  handleClose,
  errorTitle,
}) => {
  const closeModal = () => {
    if (errorMessage.includes("signature")) {
      onHide();
      handleClose();
    } else {
      onHide();
    }
  };

  return (
    <Modal
      show={show}
      size="sm"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body>
        <div className="text-holder text-center">
          <h4>{errorTitle}</h4>
          <p>{errorMessage}</p>
        </div>

        <ButtonGroup>
          <button className="custom-btn md dark" onClick={closeModal}>
            Try Again
          </button>
        </ButtonGroup>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorModal;
